import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getQuestionnaireEvaluationQuestionAttributeType, getQuestionnaireEvaluationQuestion, hasQuestionnaireEvaluationSaved, getQuestionnaireEvaluationQuestionnaireQuestionId, getQuestionnaireEvaluationParentQuestionId } from "../../../domain/questionnaireEvaluation";
import { getPhotoCaptureQuestionnaireId, hasPhotoCaptureContextUpdated, getPhotoCaptureCompanyCode, getPhotoCaptureIsTermsAndConditionAccepted, ProgressiveWideShotComponent, getPhotoCaptureAttachmentInfo, getPhotoCaptureContextId, getPhotoCaptureImageMaxWidth, photoCaptureFileUploadFailedAction, getPhotoCaptureAssignmentSubType, getPhotoCaptureAssignmentType, photoCaptureIsFileUploadStartedAction, getPhotoCaptureDisableLibrary, getPhotoCaptureAttachedArtifactIds, getPhotoCaptureFileSizeLimit, getShouldShowCommentBox, getShouldAllowMitchellIntelligent, getFoldersOptionList, photoCaptureGetFoldersRequestAction } from "../../../domain/photoCapture";
import { getGPCEvaluationDocId } from '../utilities';
import { getGPCTheme, getPRGAttachmentsWithDamagesFromQuestionnaire } from '../selectors';
const mapStateToProps = (state, ownProps) => {
    return {
        appTheme: getGPCTheme(state),
        questionText: getQuestionnaireEvaluationQuestion(state),
        questionSubType: getQuestionnaireEvaluationQuestionAttributeType(state),
        isSaveSuccess: hasQuestionnaireEvaluationSaved(state),
        evaluationDocId: getGPCEvaluationDocId(state),
        questionnaireId: getPhotoCaptureQuestionnaireId(state),
        questionnaireQuestionId: getQuestionnaireEvaluationQuestionnaireQuestionId(state),
        isContextUpdated: hasPhotoCaptureContextUpdated(state),
        companyCode: getPhotoCaptureCompanyCode(state),
        isTermsAndConditionAccepted: getPhotoCaptureIsTermsAndConditionAccepted(state),
        photoCaptureAttachmentInfo: getPhotoCaptureAttachmentInfo(state),
        attachments: getPRGAttachmentsWithDamagesFromQuestionnaire(state, ownProps.language).attachments,
        contextId: getPhotoCaptureContextId(state),
        imageMaxWidth: getPhotoCaptureImageMaxWidth(state),
        assignmentType: getPhotoCaptureAssignmentType(state),
        assignmentSubType: getPhotoCaptureAssignmentSubType(state),
        disableLibrary: getPhotoCaptureDisableLibrary(state),
        parentQuestionId: getQuestionnaireEvaluationParentQuestionId(state),
        fileSizeLimit: getPhotoCaptureFileSizeLimit(state),
        attachedArtifactIds: getPhotoCaptureAttachedArtifactIds(state),
        shouldShowCommentBox: getShouldShowCommentBox(state),
        folderOptionList: getFoldersOptionList(state),
        isMic: getShouldAllowMitchellIntelligent(state),
        missingDamages: getPRGAttachmentsWithDamagesFromQuestionnaire(state, ownProps.language).missingDamages
    };
};
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        photoCaptureFileUploadFailedAction,
        photoCaptureIsFileUploadStartedAction,
        photoCaptureGetFoldersRequestAction
    }, dispatch);
};
const ProgressiveWideShotComponentWrapper = (props) => React.createElement(ProgressiveWideShotComponent, Object.assign({}, props));
export const ConnectedProgressiveWideShotComponent = connect(mapStateToProps, mapDispatchToProps)(ProgressiveWideShotComponentWrapper);
//# sourceMappingURL=ConnectedProgressiveWideShotComponent.js.map